import { lexieBaseUrl } from '@/constants/base-url.constant';
import { hearingHealthPartnerReferralLinkMap } from '@/components/user-details/constants/hearing-health-partners.constant';
import { globalLeadSource } from 'hx-analytics/src/functions/url-lead-source/get-url-lead-source.helper';
import { isSupportedLeadSource } from 'hx-analytics/src/functions/url-lead-source/is-supported-lead-source.helper';
import { currentEnvironment } from '@/helpers/environment.helper';
export function getReferralLink() {
    var _a;
    if (!globalLeadSource || !isSupportedLeadSource(globalLeadSource)) {
        return "".concat(lexieBaseUrl, "/r/hearing-test-referral");
    }
    return hearingHealthPartnerReferralLinkMap[globalLeadSource][(_a = currentEnvironment()) !== null && _a !== void 0 ? _a : 'development'];
}
